var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticStyle:{"height":"100%","min-height":"100%"},attrs:{"id":"inspire"}},[_c('v-main',{staticStyle:{"height":"100%","padding-bottom":"0"}},[_c('router-view')],1),_vm._v(" "),_c('v-footer',{attrs:{"app":"","absolute":""}},[_c('top-nav')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c9c7d530","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 